import { SelectItem } from './util/selectItem';

export type DieselType = 'Blank' | 'Colored' | 'HVO';

export const dieselTypeItems: SelectItem<DieselType>[] = [
  { id: 'Blank', label: 'Blank' },
  { id: 'Colored', label: 'Farget' },
  { id: 'HVO', label: 'Farget HVO' },
];
